module.exports = __webpack_public_path__ + "img/admin.deffb623.png";